import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const FlagTriangleRight: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M7 22V2l10 5-10 5' }]],
];

export default FlagTriangleRight;
